export default __webpack_public_path__ + "static/media/Verificado.39d8d34c.svg";